import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { Callout } from '@bingads-webui-react/callout';

export class PopupCallout extends React.PureComponent {
  constructor(props) {
    super(props);
    if (props.view) {
      props.view.on('closeDeliveryStatusPopup', this.close);
    }
  }

  close = () => {
    if (this.props.view) {
      this.props.view.off('closeDeliveryStatusPopup');
    }
    this.props.close();
  };

  render() {
    const { target } = this.props;
    const { right } = target.getBoundingClientRect();
    const calloutMaxWidth = 325; // this value is defined in global style
    const placement = right + calloutMaxWidth > window.innerWidth ? 'left' : 'right';
    const activeElement = document && document.activeElement;

    return (
      <div onMouseLeave={this.close}>
        <Callout
          {..._.pick(this.props, 'content', 'target')}
          placement={placement}
          onClose={this.close}
          show
          popoverId={this.props.popoverId}
          closeButton={false}
          focusLockContent={activeElement === target}
          shouldUpdatePosition
        />
      </div>
    );
  }
}

PopupCallout.propTypes = {
  /**
   * the content element or text of the callout
   */
  content: PropTypes.oneOfType([
    PropTypes.element.isRequired,
    PropTypes.string.isRequired,
  ]).isRequired,
  /**
   * target of the callout, DOM element
   */
  target: PropTypes.instanceOf(Element).isRequired,
  /**
   * function called to remove callout
   */
  close: PropTypes.func.isRequired,
  /**
   * callout id
   */
  popoverId: PropTypes.string.isRequired,
  /**
   * view that has event triggered to close the popup
   */
  view: PropTypes.shape({
    on: PropTypes.func.isRequired,
    off: PropTypes.func.isRequired,
  }),
};

PopupCallout.defaultProps = {
  view: null,
};
